import { render, staticRenderFns } from "./InformationTable.vue?vue&type=template&id=5665b22e"
import script from "./InformationTable.vue?vue&type=script&lang=ts"
export * from "./InformationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports